import styled from "styled-components";

export const Wrapper = styled.div`
  font-family: "poppinsBold";
  width: 100%;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  position: relative;
  z-index: 50;
  background-color: ${(props) =>
    props.close ? "transparent" : props.setColor};
  transition: all ease-in-out 450ms;
  height: 7vh;

  ::before {
    background-color: ${(props) => props.color};
    content: "";
    width: calc(5vw);
    height: 100%;
    position: absolute;
    left: -5vw;
    top: 0;
    z-index: -20;
  }

  span.buttontitle {
    color: white;
    cursor: pointer;
    top: 50%;
    width: 100vw;
    display: flex;
    -webkit-box-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    align-items: center;
    left: 0;
    position: relative;
    text-transform: uppercase;
    transform: translateY(-50%);
    font-size: 1.5rem;
    @media (max-width: 500px) {
      font-size: 0.8rem;
    }
    .rotated {
      &:hover {
        color: #fcf48f;
      }
    }
  }

  span.buttontitle:before {
    transform: translate(-50%, -20%) rotate(90deg) scale(0.8, 1.2);

    position: absolute;
    left: 50%;
    top: unset;
    content: "➤";
    font-size: 9px;
    bottom: -13px;
  }

  span.buttontitle.close:before {
    transform: rotate(270deg) translate(1px, -30%) scale(0.8, 1.2);
    @media (max-width: 500px) {
      transform: rotate(270deg) translate(1px, -30%) scale(0.8, 1.2);
    }
  }
`;
